<template>
    <div id="app">
        <keep-alive exclude="MyReward">
            <router-view v-if="init" />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {
            init: false,
            noLogin: ['/qingE/#/', 'CCBLuckDraw/#/CCBLuckDraw?status=1'],
            isLoginHandle: false
        };
    },
    mounted() {
        // 友盟统计添加（该项目中页面放到初始化）
        const script = document.createElement("script");
        script.src = "https://s95.cnzz.com/z_stat.php?id=1277875016&web_id=1277875016";
        script.language = "JavaScript";
        document.body.appendChild(script);
        // 友盟统计添加（跳转到别的项目页面中，跳转之前）
        // if (window._czc) {
        //   window._czc.push(['_trackEvent', '一分钱坐地铁', '下载', '我要下载按钮点击量', 1, '']);
        // }

        // this.$store.dispatch('handLocalSaveLoginInfo', {
        //   token:'A758F3AAEAB5E431C7E4C12A2CD94842',
        //   deviceCoding:'5de9de2622193aa3',
        //   phone:'15300000009'
        // }).then(res => {
        //   this.init = true;
        // }).catch(err => this.init = true)
        // return

        window["iosGetInfo"] = (result) => {
            this.iosGetInfo(result);
        };
        this.toGetUser();
        document.addEventListener("visibilitychange", () => {
            // 页面变为不可见时触发
            // 页面变为可见时触发
            let arr = ['walkClose/#/shareIndex', 'walkClose/#/walkIndex', 'tenCityActive/#/tenCityActive'];
            if (!arr.some(item => window.location.href.indexOf(item) !== -1)) {
                if (document.visibilityState === "visible") {
                    this.toGetUser();
                }
            }
        });
    },
    methods: {
        toGetUser() {//获取系统信息 --> 获取用户信息
            this.init = false;
            this.$store.dispatch("getSystemInfo").then((res) => {
                if (this.noLogin.some(item => window.location.href.indexOf(item) !== -1)) return this.init = true;
                if (res.system === "ios") {
                    window.webkit.messageHandlers.QTX_H5_LOGIN_OR_GETDATA.postMessage({ loginCallBack: "iosGetInfo" });
                } else if (res.system === "android") {
                    let token = window.CarbonWebView.getTokenForH5();
                    let deviceCoding = window.CarbonWebView.getDeviceCoding();
                    let phone = window.CarbonWebView.getPhoneForH5();
                    let platform = window.CarbonWebView.getPlatformH5();//手机型号
                    let version = window.CarbonWebView.getVersionH5();//app版本
                    let language = window.CarbonWebView.getLanguageH5();//android or ios
                    let systemyersion = window.CarbonWebView.getSystemyersionH5(); //系统的版本号
                    let statusBarHeight = window.CarbonWebView.getStatusBarHeight() / 2.5; //状态栏高度


                    if (token) {
                        this.$store.dispatch('handLocalSaveLoginInfo', {
                            token,
                            deviceCoding,
                            phone,
                            platform,
                            version,
                            language,
                            systemyersion,
                            statusBarHeight
                        }).then(res => {
                            this.init = true
                        })
                    } else {
                        if (this.isLoginHandle) {
                            this.init = true;
                        } else {
                            this.isLoginHandle = true;
                            window.CarbonWebView.loginForH5()
                        }
                    }
                } else {
                    this.init = true;
                }
            })
                .catch((err) => {
                    this.init = true
                    console.error(err);
                });
        },
        iosGetInfo(obj) { //获取ios用户信息
            if (obj.user_is_login === "1") {
                this.$store.dispatch('handLocalSaveLoginInfo', {
                    token: obj.user_token,
                    deviceCoding: obj.phone_device_coding,
                    phone: obj.user_phone,
                    platform: obj.phone_model,//手机型号
                    version: obj.app_version,//app版本
                    language: obj.phone_system_name,//android or ios
                    systemyersion: obj.phone_system_version,//系统的版本号
                    statusBarHeight: obj.phone_has_header == 1 ? 83 / 2.5 : 49 / 2.5 //状态栏高度，转px
                }).then(res => {
                    this.init = true;
                })
            } else {
                window.webkit.messageHandlers.QTX_H5_LOGIN_OR_GETDATA.postMessage({ loginCallBack: "iosGetInfo" });
            }
        }
    }
};
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
